'use client';

import { useState, useEffect } from 'react';
import Navigation from '@/components/Navigation';
import Hero from '@/components/Hero';
import About from '@/components/About';
import Gallery from '@/components/Gallery';
import Amenities from '@/components/Amenities';
import Booking from '@/components/Booking';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import FlyingBird from '@/components/FlyingBird';

export default function App(): JSX.Element {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={`min-h-screen transition-opacity duration-700 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
      <FlyingBird />
      <Navigation />
      <main>
        <Hero />
        <About />
        <Gallery />
        <Amenities />
        <Booking />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}